import React from 'react';

export default function TextComposer({
  input,
  setInput,
  isSending,
  onSubmit,
  onOpenTranscribe,
  onOpenLiveVoice,
  isThreadLoading = false,
  isEditing = false,
  onCancelEdit,
}) {
  return (
    <form onSubmit={onSubmit} className="br-composer shrink-0 space-y-3">
      {isEditing && <div className="flex items-center justify-between rounded-lg border border-cyan-200/20 bg-cyan-200/10 px-3 py-2 text-xs text-cyan-50"><span>Editing this message. Sending will replace it and regenerate the reply.</span><button type="button" onClick={onCancelEdit} className="ml-3 underline underline-offset-2">Cancel</button></div>}
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <input
          data-testid="chat-input"
          type="text"
          placeholder="What’s on your mind?"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="br-composer__input min-w-0 w-full flex-1 rounded-xl border border-white/30 bg-white/10 px-4 py-3 text-white placeholder-white/50 focus:outline-none"
          aria-describedby={isSending ? 'br-composer-pending-hint' : undefined}
        />

        {isSending && <span id="br-composer-pending-hint" className="sr-only">You can prepare your next message while BrightResolve responds.</span>}

        <div className="grid grid-cols-3 gap-2 sm:flex sm:shrink-0">
          <button
            type="button"
            onClick={onOpenTranscribe}
            disabled={isThreadLoading}
            className="br-composer__mode min-w-0 rounded-xl border border-white/20 bg-white/10 px-2 py-3 text-sm font-medium text-white transition sm:px-4"
            data-testid="transcribe-button"
          >
            Transcribe
          </button>

          <button
            type="button"
            onClick={onOpenLiveVoice}
            disabled={isThreadLoading}
            className="br-composer__mode min-w-0 rounded-xl border border-white/20 bg-white/10 px-2 py-3 text-sm font-medium text-white transition sm:px-4"
            data-testid="live-chat-button"
          >
            Live
          </button>

          <button
            data-testid="chat-send"
            type="submit"
            className="br-button br-button--primary min-w-0 px-3 py-3 sm:px-6"
            disabled={!input.trim() || isSending || isThreadLoading}
            aria-label={isSending ? 'BrightResolve is preparing a response' : 'Send message'}
          >
            {isSending ? (
              <span className="br-send-loading" aria-hidden="true"><i /><i /><i /></span>
            ) : 'Send'}
          </button>
        </div>
      </div>
    </form>
  );
}
